import { createIdentifier } from "app-base/runtime/identifier"

export function newUUID(): string {
  return createIdentifier(globalThis.crypto);
}
